import React, { FC } from "react";
import { useHistory } from "react-router-dom";

import {
  careerSheetPath,
  careerMapPath,
  careerQuestionPath,
} from "../../../../store/student";
import PieChart from "../../../../atoms/Career/PieChart";
import { ReactComponent as IconComplete } from "../../../../assets/images/Career/icon_complete.svg";
import { ReactComponent as ArrowRight } from "../../../../assets/images/Career/arrow_right.svg";

import styles from "./Banner.module.scss";

type BannerType = "sheet" | "map" | "questionGenerating" | "question";

type Props = {
  type: BannerType;
  createCareerSheets?: () => void;
  chartCount?: number;
  chartLength?: number;
  questionTitle?: string;
};

const Banner: FC<Props> = ({
  type,
  createCareerSheets,
  chartCount,
  chartLength,
  questionTitle,
}) => {
  const history = useHistory();

  const graphicElement = {
    sheet: (
      <>
        <IconComplete />
        <span className={styles.label}>complete!</span>
      </>
    ),
    map: (
      <>
        <IconComplete />
        <span className={styles.label}>complete!</span>
      </>
    ),
    question: (
      <PieChart size={50} count={chartCount ?? 0} length={chartLength ?? 0} />
    ),
    questionGenerating: <span className={styles.pie} />,
  };

  const messageElement = {
    sheet: (
      <>
        <span className={styles.highlight}>
          キャリア開拓MAPの申請条件クリア！
        </span>
        <br className={styles.isPc} />
        今のキャリアをキャリア開拓シートに記入して、キャリア開拓MAPを申請しよう。
      </>
    ),
    map: (
      <>
        <span className={styles.highlight}>キャリア開拓MAP完成！</span>
        <br className={styles.isPc} />
        キャリアMAPを見ると、次回からキャリア開拓クエスチョンが表示されます。
      </>
    ),
    question: (
      <>
        <span className={styles.highlight}>Q.キャリア開拓クエスチョン</span>
        <br />
        {questionTitle}
      </>
    ),
    questionGenerating: (
      <>
        <span className={styles.highlight}>
          現在、あなただけの「キャリア開拓クエスチョン」を作成しています。
        </span>
        <br />
        完成次第、こちらに表示されます。
      </>
    ),
  };

  const linkPath: Partial<Record<BannerType, string>> = {
    sheet: careerSheetPath,
    map: careerMapPath,
    question: `${careerQuestionPath}/${
      chartCount === 0 || chartCount ? chartCount + 1 : 0
    }`,
  };

  const linkLabel: Partial<Record<BannerType, string>> = {
    sheet: "シートへ",
    map: "MAPを見る",
    question: "回答する",
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.graphic}>{graphicElement[type]}</div>
      <div className={styles.message}>{messageElement[type]}</div>
      <button
        className={styles.link}
        onClick={() => {
          createCareerSheets?.();
          linkPath[type] && history.push(linkPath[type]);
        }}
      >
        {linkLabel[type] && (
          <>
            <span className={styles.label}>{linkLabel[type]}</span>
            <ArrowRight />
          </>
        )}
      </button>
    </div>
  );
};

export default Banner;
